import React, { useState } from "react";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
// import MenuOpenRoundedIcon from "@mui/icons-material/MenuOpenRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { useNavigate } from "react-router-dom";

const Navbar2 = () => {
  const [showMenu, setShowMenu] = useState(true);
  const navigate = useNavigate();
  return (
    <div className="fixed z-50 lg:pl-20 sm: pl-6 lg:pr-20 sm: pr-6 w-full h-14 backdrop-blur-md flex justify-between items-center">
      <p
        onClick={() => navigate("/")}
        className="text-white font-semibold lg:text-3xl sm: text-xl mt-20"
      >
        Pushkar
      </p>

      <div className="lg:flex gap-10 sm: hidden text-base text-white">
        <p onClick={() => navigate("/")} className=" cursor-pointer ">
          Home
        </p>
      </div>

      <div className=" relative sm: flex lg:hidden text-white">
        {showMenu ? (
          <MenuRoundedIcon onClick={() => setShowMenu(!showMenu)} />
        ) : (
          <CloseRoundedIcon onClick={() => setShowMenu(!showMenu)} />
        )}

        {!showMenu && (
          <div className=" absolute top-4 right-4">
            <div className=" text-xs font-medium text-gray-800 p-4  rounded-xl flex flex-col gap-2 bg-white">
              <p onClick={() => navigate("/")} className=" cursor-pointer ">
                Home
              </p>
            </div>
          </div>
        )}
      </div>

      {/* </div> */}
    </div>
  );
};

export default Navbar2;
